import { useEffect } from "react";
import useBodyScrollLock from "@/hooks/useBodyScrollLock";
import styles from "./LogoutModal.module.css";

export default function LogoutModal({ open, loading = false, onClose, onConfirm }) {
  useBodyScrollLock(open);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape" && !loading) onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);

    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, loading, onClose]);

  if (!open) return null;

  return (
    <div className={styles.root} role="presentation">
      <button
        type="button"
        className={styles.overlay}
        aria-label="Close logout dialog"
        onClick={loading ? undefined : onClose}
        disabled={loading}
      />

      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="logout-modal-title"
      >
        <h2 id="logout-modal-title" className={styles.title}>
          Logout
        </h2>
        <p className={styles.description}>You're about to log out. Are you sure?</p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Logging out..." : "Logout"}
          </button>
        </div>
      </div>
    </div>
  );
}
